import { useState, useEffect, Fragment} from "react";
import { Button, FormControlLabel, Grid, Paper, Radio, RadioGroup, Stack, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Tooltip, Box,  Collapse, IconButton, Checkbox, Modal, Input, Snackbar} from "@mui/material";
import { GETALLPRODUCTS, GETCATEGORIESLIST, GETCATEGORYFIELDS, GETCAMPAIGN, ADDCAMPAIGN, UPDATECAMPAIGN, GETCOMPARISONLIST, DOWNLOADCOMPARISONDATA, GETPRICECOMPARISONDATA } from "../../api/apiConfig";
import { apiGet, apiPost } from "../../utils/services";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { AnalyticsService } from "../../utils/Analytics";
import { BiLoaderCircle, BiCheckCircle, BiDownload } from "react-icons/bi";
import { FaInfoCircle, FaTimesCircle } from "react-icons/fa";
import { Title } from "../../components/atoms";
import { Toaster, toast } from 'react-hot-toast';
import Popup from "../../components/atoms/Popup/Popup";
import Switch from "@mui/material/Switch";


const ConfirmTopDealPrices = ({openModal, topProducts, selectedCategory, selectedModel, onClose, dateDetails, refreshData, isTopDealPreview, isPriceSyncEnabled}) =>{
        
    const [state, setState] = useState({
        productCategories: []
        
    });
    const [isLoading, setIsLoading] = useState(false);
     const [productMap, setProductMap] = useState([...topProducts]);
     const [isError, setIsError] = useState({error:false, msg:""});
     const [openConfirmModal, setOpenConfirmModal] = useState(openModal);
     const [isSingleProdView, setIsSingleProdView] = useState(true);   
     const [showPriceDisclaimer, setShowPriceDisclaimer] = useState(false);
     const [isTcsFunded, setTcsFunded] = useState(localStorage.getItem("roleId") === "1");  
     const [popup, setPopup] = useState({})

     const {        
        
        startDate,
        endDate,
        
        discount,  
             
        
       
    } = state;

    const updateState = (data) => setState((prevState) => ({ ...prevState, ...data }));
    const openPopup = (name, e) => {
        setPopup({ ...popup, [name]: popup[name] ? null : e.currentTarget })
    }
    useEffect( () => {
       
        if(dateDetails.showDate)
        {
            setIsSingleProdView(true);
            updateState({startDate: dateDetails.startDate, endDate: dateDetails.endDate});
        }
        else
        {
            setIsSingleProdView(false);
            updateState({startDate: dateDetails.startDate, endDate: dateDetails.endDate});
        }
        setOpenConfirmModal(openModal);
       
       
    }, [openModal]);
        
   useEffect(() => {
        if(isPriceSyncEnabled && !isTcsFunded){
            setShowPriceDisclaimer(true);
     setTimeout(() => {
      setShowPriceDisclaimer(false);
    }, 60000);
        }
   }, []);
    
     const addCampaign = async (products) => {
        setIsLoading(true);
        
       
        try {
        if(
            startDate === null 
            || endDate === null 
            || startDate === undefined 
            || startDate === "" 
            || endDate === undefined 
            || endDate === ""
            || products === null
            || products === undefined)
        {
           
           setIsError({error:true, msg:"You must select start and end dates"});
            setIsLoading(false);
        
            return;
        }
        setIsError({error:false, msg:""});
        
        
        
let totalDiscount = 0;
let variantCount = 0;


products.forEach(product => {
    
    product.variants.forEach(variant => {
        
        totalDiscount += parseFloat(variant.percentageDiscount);
        
        variantCount++;
    });
});


const averageDiscount = totalDiscount / variantCount;


        let name = "";
        if(
            selectedCategory.value === undefined
            ||
            selectedModel.value === undefined
             )
             {
                
                name = products[0].productName;
             }
             else{
                name = selectedCategory?.label + " / " + selectedModel?.label;
             }
        const res = await apiPost(ADDCAMPAIGN, {
            ProductCategoryId: selectedCategory?.value,
            ModelId: selectedModel?.value,
            discount: averageDiscount,
            name: name,
            startDate: startDate != null ? moment(startDate).format('DD/MM/yyyy') : "",
            endDate: endDate != null ? moment(endDate).format('DD/MM/yyyy') : "",
            products: products, 
            isTcsFunded:isTcsFunded
        });
        if (res) {
            AnalyticsService.logEvent("CAMPAIGN_ADDED_SUCCESSFULLY");
           
            toast.success("CAMPAIGN ADDED SUCCESSFULLY");
            
        }
        else{
            console.log("failed");
            toast.error("Failed to create campaign");
        }
    }
    catch (error) {
        console.error("An error occurred:", error);        
        toast.error("An error occurred while creating the campaign");
    }
        setIsLoading(false);
        
        setOpenConfirmModal(false);
        onClose(true, isSingleProdView, products[0].productId);
        refreshData();
    };
     const handleOnProductUpdate = (product) => {
           
            if(product != null || product != undefined)
            {
                let productIndex = productMap.findIndex(prod=> prod.productId == product.productId);
                productMap[productIndex] = product;
                setProductMap([...productMap]);
               setIsError({error:false, msg:""});
            }
     }
     const handleAddCampaign = async ()=>{
        let productsWithDiscount = productMap.filter(product => 
            product.variants.some(variant => variant.percentageDiscount > 0)
          );
        if(productsWithDiscount === null || productsWithDiscount === undefined || productsWithDiscount.length === 0)
        {
            setIsError({error:true, msg:"No product Selected! please adjust variant prices to reflect discount to proceed"});
            return;

        }
        await addCampaign(productMap);
     }
    const handleCancelOnclick = ()=>
    {
        
        setOpenConfirmModal(false);         
         setIsError({error:false, msg:""});
         onClose(false, isSingleProdView, topProducts[0].productId);
         
    }    
    
    return (
        <Modal style={{ overflowX: 'auto', overflowY: 'auto', padding: '20px', width: '100% !important' }}
        open={openConfirmModal} center maxWidth={false}>
            
        <Paper className="padding space-top" sx={{ width: '100% !important', overflow: 'hidden', padding: '30px' }} maxWidth={false}>
        <div style={{textAlign: 'center'}} className="bold lg space-bottom2">Approve/Edit Top Deal Prices as Follows:</div>
        {isPriceSyncEnabled && ( <div style={{textAlign: 'right'}}>
                <Tooltip title="view important notice">
                  <IconButton  onClick={()=>{setShowPriceDisclaimer(true)}}>
                <InfoIcon />
                </IconButton>
                </Tooltip>
                <div style={{textAlign: 'center'}}>
                <Snackbar style={{textAlign: 'center !important'}}
              open={showPriceDisclaimer}
              onClose={()=>{setShowPriceDisclaimer(false)}}
              message={
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {/* <img
                    src="path-to-your-image" // Replace with your image path
                    alt="Alert Icon"
                    style={{ width: '20px', height: '20px', marginRight: '8px' }} // Adjust size and margin as needed
                  /> */}
                  We have detected an integration with either WooCommerce or Shopify with price sync turned on, please note that creating a top deal automatically turns off price sync.
                </div>
              }
              action={
                <IconButton size="small" color="inherit" onClick={()=>{setShowPriceDisclaimer(false)}}
                sx={{
                    position: 'absolute', // Position it absolutely within SnackbarContent
                    top: 0, // Space from the top
                    right: 8, // Space from the right
                  }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              sx={{
                '& .MuiSnackbarContent-root': {
                  justifyContent: 'center', // Center the message text
                  position: 'relative',
                },
                '& .MuiSnackbarContent-message': {
                  marginTop: '12px', // Add margin to the message
                  textAlign: 'center', // Ensure text is centered
                  width: '100%',
                },
              }}
            />
            </div>
            </div>)}
        {localStorage.getItem("roleId") === "1" &&(<div style={{textAlign: 'right', fontSize: 12, color: isTcsFunded ? 'green' : "navy", marginRight: '10px'}} > {isTcsFunded ? "Tcs Funded" : "Merchant Funded"}
            <Switch
                    color="success"
                    checked={isTcsFunded}
                    onChange={()=>{setTcsFunded(!isTcsFunded)}}
                  />
        </div>)}
        {isError.error &&(<div className="error bold"  style={{textAlign: 'left'}} >{isError.msg}</div>)}
        {isSingleProdView && (<div className="space-top space-bottom2" style={{textAlign: 'center'}} >
        <Grid container spacing={3}>
        <Grid item xs={12} sm={3} md={3} style={{ textAlign: 'left'}}>
                                <div id="categorySelection">
                                    <Title text={"Start Date"} className="formLabelCls" />
                                    <div style={{ marginTop: '8px' }}>
                                        <DatePicker
                                            placeholderText="Select Start Date"
                                            className="datepicker click"
                                            onChange={(date) => {
                                                updateState({ startDate: date })
                                            }}
                                            selectsStart
                                            showMonthDropdown
                                            showYearDropdown
                                            value={startDate != null && moment(startDate).format('DD/MM/yyyy')}
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            selected={startDate}
                                            startDate={startDate}
                                            endDate={endDate}
                                            maxDate={endDate}
                                        />
                                    </div>

                                </div>
                            </Grid>
                            <Grid item xs={12} sm={3} md={3} style={{ textAlign: 'left'}}>
                                <div id="categorySelection">
                                    <Title  text={"End Date"} className="formLabelCls" />
                                    <div style={{ marginTop: '8px' }}>
                                        <DatePicker
                                            placeholderText="Select End Date"
                                            className="datepicker click"
                                            onChange={(date) => {
                                                updateState({ endDate: date })
                                            }}
                                            selectsStart
                                            showMonthDropdown
                                            showYearDropdown
                                            value={endDate != null && moment(endDate).format('DD/MM/yyyy')}
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            selected={endDate}
                                            startDate={startDate}
                                            endDate={endDate}
                                            minDate={startDate}
                                        />
                                    </div>
                                </div>
                                </Grid>
                                </Grid>
                               </div> )}
                               
                    <TableContainer  sx={{
                                            "&::-webkit-scrollbar": {
                                            width: 5,
                                            height: 5
                                            },
                                            "&::-webkit-scrollbar-track": {
                                            backgroundColor: "white"
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                            backgroundColor: "red",
                                            borderRadius: 3,
                                            
                                            },
                                            
                                        }}>
                        <Table >
                            <TableHead>
                                <TableRow>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        color="primary"
                                        indeterminate={true}
                                        checked={true}
                                        
                                        inputProps={{
                                        'aria-label': 'select all desserts',
                                        }}
                                    />
                                </TableCell>

                                <TableCell>

                                </TableCell>
                                    <TableCell style={{   background: 'white',  overflow: 'hidden', textOverflow: 'ellipsis'}} ><span className='sm'>Product Name</span></TableCell>
                                    <TableCell style={{background: 'white',   overflow: 'hidden', textOverflow: 'ellipsis'}}><span className='sm'>Current Price</span></TableCell>                                        
                                    
                                    <TableCell style={{overflow: 'hidden', textOverflow: 'ellipsis'}}><span className='sm'>Proposed Price</span></TableCell>
                                    <TableCell style={{overflow: 'hidden', textOverflow: 'ellipsis'}}><span className='sm'>Discount (%)</span></TableCell>
                                    <TableCell style={{overflow: 'hidden', textOverflow: 'ellipsis'}}>Is Competitive?</TableCell>
                                    
                                    
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            
                                {productMap?.map((data) => {
                                    console.log("data", data);
                                    
                                    return (
                                        
                                        <Row key={data.productId} prod={data} onUpdateState={handleOnProductUpdate} />
                                    )
                                 
                                })}
                               
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <div className="space-top" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>

                        <Button startIcon={isLoading && <BiLoaderCircle sx={{ color: "#8D0C18" }} />} onClick={() => handleCancelOnclick()} style={{ backgroundColor: 'black', color: 'white' }} variant="contained">Cancel</Button>
                        {!isTopDealPreview && (<Button startIcon={isLoading && <BiLoaderCircle sx={{ color: "#8D0C18" }} />} onClick={() => handleAddCampaign()} style={{ backgroundColor: 'green', color: 'white' }}  variant="contained">Proceed</Button>)}
                        
                        </div>
                        
                    </Paper>
        </Modal>
    )
}
function Row({prod, onUpdateState}) {
    
   const  product  = JSON.parse(JSON.stringify(prod));
   const variants = product.variants;
   
 
    const [open, setOpen] = useState(false);
    const [variantValues, setVariantValues] = useState([...variants]);
    let prices = variantValues.map(variant => {
                        
        return parseFloat(variant.price);
      });
    let proposedPrice = variantValues.map(variant => {
                        
        return parseFloat(variant.proposedPrice);
      });
    

    const [isLowestPrice, setIsLowestPrice] = useState(product.isLowestPrice);
    const [minPrice, setMinPrice] = useState(Math.min(...proposedPrice));
    const [minVariantPrice, setMinVariantPrice] = useState(Math.min(...prices));
    const [percentageValue, setPercentageValue] = useState(product.percentageDiscount);
    
                     const handleInputChange = (event, index) => {
                        console.log("index", index);
                        var copyOfVariantValues = JSON.parse(JSON.stringify(variantValues));
                        const updatedVariantValues = [...copyOfVariantValues];
                        
                        let isVariantLowestPrice = true;
                        let competitorPriceArray = getRetailPriceArray(product);  
                        if(competitorPriceArray.length > 0)
                        {
                            if(Math.min(...competitorPriceArray) <=  updatedVariantValues[index].proposedPrice)
                            isVariantLowestPrice = false
                        }
           
                            updatedVariantValues[index] = {
                                ...updatedVariantValues[index],
                                proposedPrice: event.target.value,
                                isLowestPrice: isVariantLowestPrice,
                                percentageDiscount: (((updatedVariantValues[index].price - event.target.value) / updatedVariantValues[index].price) * 100).toFixed(2)
                            };
                            
                            let discounts = updatedVariantValues.map(variant => {
                        
                                return parseFloat(variant.percentageDiscount);
                              });

                              if(Math.min(...discounts) < 0) return;

                              const allSameDiscount = discounts.every((value, index, array) => value === array[0]);
                              if(allSameDiscount)
                              {
                                setPercentageValue(discounts[0]);
                              }
                              else
                              {
                                let txt = "from " + Math.min(...discounts) + "%"
                                setPercentageValue(txt);
                              }
                            

                           
                    //   const copyOfTopDeal = JSON.parse(JSON.stringify(topProducts));
                    //      console.log("copy of top", copyOfTopDeal);

                    //    let productIndex = copyOfTopDeal.findIndex(prod=> prod.productId == product.productId);
                       const copyOfVariants = JSON.parse(JSON.stringify(updatedVariantValues));

                          product.variants = [...copyOfVariants];                         
                       

                     
                      //setNewState(JSON.stringify(copyOfTopDeal));
                      onUpdateState(product);
                      setVariantValues(updatedVariantValues);
                       
                       checkIfProductIsBestPrice(updatedVariantValues);
                       
                      }
                      const getRetailPriceArray = (product) => {
                        let competitorPriceArray = [];
                
                        if(product.cricketHockey != "" )
                        {
                            console.log("cricket hockey", product.cricketHockey);
                            competitorPriceArray.push(parseFloat(product.cricketHockey.replace(/[^0-9.]/g, '')));
                        }
                        if(product.talentCricket != "")
                        {
                            competitorPriceArray.push(parseFloat(product.talentCricket.replace(/[^0-9.]/g, '')));
                        }
                        if(product.ozwat != "")
                        {
                            competitorPriceArray.push(parseFloat(product.ozwat.replace(/[^0-9.]/g, '')));
                        }
                        if(product.allRoundCricket != "")
                        {
                            competitorPriceArray.push(parseFloat(product.allRoundCricket.replace(/[^0-9.]/g, '')));
                        }
                        if(product.romida != "")
                        {
                            competitorPriceArray.push(parseFloat(product.romida.replace(/[^0-9.]/g, '')));
                        }
                        if(product.mrCricket != "")
                        {
                            competitorPriceArray.push(parseFloat(product.mrCricket.replace(/[^0-9.]/g, '')));
                        }
                        if(product.morant != "")
                        {
                            competitorPriceArray.push(parseFloat(product.morant.replace(/[^0-9.]/g, '')));
                        }
                        if(product.serious != "")
                        {
                            competitorPriceArray.push(parseFloat(product.serious.replace(/[^0-9.]/g, '')));
                        }
                        console.log("price array", competitorPriceArray, "typeof", typeof competitorPriceArray[0]);
                
                        return competitorPriceArray;
                       
                    }
    const checkIfProductIsBestPrice = (updatedVariantValues) =>
    {
        let competitorPriceArray = getRetailPriceArray(product);  
        if(competitorPriceArray.length > 0)
        {
           
            console.log("in my check", updatedVariantValues[0].proposedPrice);
            let newprices = updatedVariantValues.map(variant => {
                        
                return parseFloat(variant.proposedPrice);
              });
            
              
            setMinPrice(Math.min(...newprices));                
            setIsLowestPrice(Math.min(...newprices) < (Math.min(...competitorPriceArray)));
        }

        
        
    }
                      console.log(product.isLowestPrice, product.productName);
                     
                                                
                      
                      
  
    return (
      <Fragment>

        <TableRow 
        hover
       
        role="checkbox"
        aria-checked={!(percentageValue <= 0)}
        tabIndex={-1}
        key={1}
        selected={!(percentageValue <= 0)}
        sx={{ cursor: 'pointer' }}>
        <TableCell padding="checkbox">
                                    <Checkbox
                                        color= "primary"
                                        indeterminate={!(percentageValue <= 0)}
                                        checked={!(percentageValue <= 0)}
                                        
                                        inputProps={{
                                        'aria-label': 'select all desserts',
                                        }}
                                    />
                                </TableCell>
          <TableCell>
          
              {open ? <KeyboardArrowUpIcon  color="green" onClick={() => setOpen(!open)}/> :<KeyboardArrowDownIcon  color="green" onClick={() => setOpen(!open)}/>  }
           
          </TableCell>
          <TableCell component="th" scope="row">
            {product.productName}
          </TableCell>
          <TableCell>{minVariantPrice}</TableCell>
          <TableCell >{minPrice}</TableCell>
          <TableCell>{percentageValue}</TableCell>
          <TableCell>{isLowestPrice ? <BiCheckCircle size={"12px"} color="green"/> : <FaTimesCircle size={"12px"} color="red"/>}</TableCell>
          
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>                    
                <Table size="small" aria-label="variants">
                  <TableHead>
                    <TableRow>
                    <TableCell style={{ width: '79px' }}>      </TableCell>
                      <TableCell style={{ width: '287px' }}>Variant</TableCell>
                      <TableCell>Current Price</TableCell>
                      <TableCell >Top Deal Price</TableCell>
                      <TableCell >Discount (%)</TableCell>
                      <TableCell >Is Competitive</TableCell>
                      {/* <TableCell align="right">Total price ($)</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {variantValues.map((variant, index) => {
                     
                   console.log("checking lowest price",variant.isLowestPrice);
                    return(
                    
                      <TableRow key={variant.id}>
                        <TableCell style={{ width: '79px' }}>      </TableCell>
                        <TableCell style={{ width: '287px' }} component="th" scope="row">
                          {variant.title}
                        </TableCell>
                        <TableCell>
                        {variant.price}
                        </TableCell>
                        <TableCell >
                        <Input  
                            type="number"
                            step="0.01" // Allows input to be rounded to two decimal places
                            value ={variantValues[index].proposedPrice}
                            onChange={(event) => handleInputChange(event, index)}
                            style={{ maxWidth: '60px' }} 
                            // onInput={(event) => {
                                
                            //     event.target.value = event.target.value.replace(/[^0-9.]/g, '');
                            // }}
                        >
                        </Input>

                        </TableCell>
                        <TableCell>
                        {variantValues[index].percentageDiscount}
                        </TableCell>
                        <TableCell>
                         {variantValues[index].isLowestPrice ? <BiCheckCircle size={"12px"} color="green"/> : <FaTimesCircle size={"12px"} color="red"/>}
                        </TableCell>
                      </TableRow>
                    )})}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </Fragment>
    );
  }

  export default ConfirmTopDealPrices;